export default class MapboxSelector {
  static supportsWebGL2(): boolean {
    try {
      const canvas = document.createElement('canvas');
      return !!canvas.getContext('webgl2');
    } catch {
      return false;
    }
  }

  static async load(): Promise<typeof import('mapbox-gl-v2') | typeof import('mapbox-gl-v3')> {
    if (this.supportsWebGL2()) {
      return await import('mapbox-gl-v3');
    } else {
      return await import('mapbox-gl-v2');
    }
  }


}